import EditGroupForm from './EditGroupForm'
import enhance from './EditGroupForm.enhancer.js'

export default enhance(EditGroupForm)



// WEBPACK FOOTER //
// ./src/components/organisms/EditGroupForm/index.js